(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.dataset.scrollRevealed = '';
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  function observeElements() {
    document.querySelectorAll('.scroll-reveal:not([data-scroll-revealed])').forEach((el) => {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeElements);
  } else {
    observeElements();
  }

  // Re-observe after view transitions (for SPA-like navigation)
  window.addEventListener('pagereveal', () => {
    requestAnimationFrame(observeElements);
  });
})();
